<template>
  <Card variant="tertiary" class="renter-profile-application-artifact component">
    <View justify="space-between" direction="column" gap="sm" class="position-wrap">
      <View direction="column" gap="xs">
        <View gap="sm" align="center">
          <Text variant="label-medium">{{ title }}</Text>
          <Text variant="label-small" class="valid-til" :class="{ expired: expired }" v-if="validityText">
            {{ validityText }}
          </Text>
        </View>

        <Text variant="body-medium" color="secondary">{{ description }}</Text>
      </View>

      <slot />
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, Text, View } from '@tallo/design-system';

defineProps<{
  validityText?: string | null;
  expired?: boolean | null;
  title: string;
  description: string;
}>();
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

@include screen-min-sm {
  .position-wrap {
    flex-direction: row;
  }
}

.valid-til {
  color: var(--t-color-green-600);

  &.expired {
    color: var(--t-color-red-600);
  }
}
</style>
